import React, { useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled, { createGlobalStyle } from 'styled-components'

import Text from '../../ui/Text'
import { WidgetDropdownFilterOptions } from '../widget-dropdown-filter-options'
import { WidgetDropdownFilterSearch } from '../widget-dropdown-filter-search'
import { Button } from '../button'
import { LogTypes } from '../../common/constants/LogTypes'

const Modal = styled.div`
    z-index: 1050;
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`

const ModalHeader = styled.div`
    padding: 19px 17px 7px 17px;
    border-bottom: 1px solid #e5e5e5;
    font-weight: 800;
    font-size: 18px;
    text-transform: uppercase;
`

const ModalHeaderTitle = styled.div`
    padding-bottom: 21px;
`

const ModalOptions = styled.div`
    content-visibility: auto;
    height: 442px;
    overflow: scroll;
`

const ModalButtons = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 16px;
    border-top: 1px solid #dddddd;
`

const ModalContent = styled.div`
    background-color: #ffffff;
    background-clip: padding-box;
    border: 1px solid #00000033;
    border-radius: 6px;
    box-shadow: 0 3px 9px #00000088;
    margin: 15px;
`

const NonScrollableBodyStyle = createGlobalStyle`
    body {
        overflow: hidden;
    }
`

const ModalBackdrop = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background-color: #000000;
    opacity: 0.5;
`

export type WidgetDropdownFilterModalProps = {
    options: Array<LogTypes>
    defaultOptions: Array<LogTypes>
    onChange: (options: Array<LogTypes>) => void
    onClose: () => void
    className?: ClassName
    style?: React.CSSProperties
}

export function WidgetDropdownFilterModal({
    className,
    style,
    options,
    defaultOptions,
    onChange,
    onClose,
}: WidgetDropdownFilterModalProps): React.ReactElement {
    const [modalSelectedOptions, setModalSelectedOptions] = useState([...options])
    const [visibleOptions, setVisibleOptions] = useState<Array<LogTypes>>([])

    return (
        <div className={cn(className)} style={style} data-testid="WidgetDropdownFilterModal">
            <NonScrollableBodyStyle />
            <ModalBackdrop />
            <Modal>
                <ModalContent>
                    <ModalHeader data-testid="action-filters">
                        <ModalHeaderTitle>
                            <Text code="lblActionFilters" />
                        </ModalHeaderTitle>
                        <WidgetDropdownFilterSearch
                            setVisibleOptions={setVisibleOptions}
                            visibleOptions={visibleOptions}
                            defaultOptions={defaultOptions}
                        />
                    </ModalHeader>
                    <ModalOptions>
                        <WidgetDropdownFilterOptions
                            onChange={(newOptions: Array<LogTypes>) => setModalSelectedOptions(newOptions)}
                            options={modalSelectedOptions}
                            visibleOptions={visibleOptions}
                            defaultOptions={defaultOptions}
                        />
                    </ModalOptions>
                    <ModalButtons>
                        <Button
                            onClick={() => {
                                onChange(modalSelectedOptions)
                                onClose()
                            }}
                            code="btnSave"
                            dataTestId="btn-save-filter"
                        ></Button>
                        <Button onClick={onClose} code="btnCancel"></Button>
                    </ModalButtons>
                </ModalContent>
            </Modal>
        </div>
    )
}
